// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 769px) {\n.modal-periodo-vigencia .modal-card {\n    width: 700px;\n}\n}", ""]);
// Exports
module.exports = exports;
